<template>
	<!-- Multi-selection edit bar (fixed position, centered) -->
	<multi-selection-edit-bar v-if="isMultiSelection" />

	<!-- Single-element edit bar (positioned near element) -->
	<div
		v-else
		:style="{top: `${computedY}px`, left: `${computedX}px`}"
		ref="editBar"
		class="edit-bar"
	>
		<quick-node-bar v-if="currentNode && !isContentFormOpened"></quick-node-bar>
		<quick-edge-bar v-if="currentEdge"></quick-edge-bar>
	</div>
</template>

<script>
import {computed} from 'vue';
import {useStore} from 'vuex';
import {Scale} from '@/services/canvas/Scale';
import { useMapArea } from '@/modules/map-editor';
import QuickNodeBar from './node/QuickNodeBar';
import QuickEdgeBar from './edge/QuickEdgeBar';
import MultiSelectionEditBar from './multi-selection/MultiSelectionEditBar.vue';
import {DASHBOARD_OPTIONS} from '@/models/DASHBOARD_OPTIONS';
import {POPUP_SETTINGS} from "@/models/POPUP_SETTINGS";
export default {
	components: {QuickEdgeBar, QuickNodeBar, MultiSelectionEditBar},
	props: {
		ctx: {
			type: Object,
			default: null
		},
		zoomLevel: {
			type: Number,
			default: 1
		},
		pixelRatio: {
			type: Number,
			default: 1
		}
	},
	setup(props) {
		const store = useStore();
		const { mapAreaService } = useMapArea();
		const currentNode = computed(() => store.getters['nodes/getSelectedNode']);
		const currentEdge = computed(() => store.getters['edges/getSelectedEdge']);
		const isMultiSelection = computed(() => store.getters['nodes/isMultiSelection']);
		const PADDING_VERTICAL = 23;
		const EDIT_BAR_WIDTH = 500; // fixed width of edit bar;

		const NODE_DESIGN = DASHBOARD_OPTIONS.CREATE.GROUPS.NODE.NODE_DESIGN.VALUE;
		const optionActive = computed(() => store.getters["dashboardOptions/getOptionActive"]);
		const isNodeDesignSettingsOpened = computed(() => optionActive.value?.VALUE === NODE_DESIGN);

		const currentPopup = computed(() => store.getters["settingsPopup/getCurrentPopup"]);
		const isContentFormOpened = computed(() => currentPopup.value?.popup === POPUP_SETTINGS.CONTENT.SECTIONS['0'].CONTENT_FORM.VALUE);

		const nodeBarX = computed(() =>
			Scale.x(currentNode.value?.x + mapAreaService.x, props.ctx.canvas.width / 2, props.zoomLevel) / props.pixelRatio - (EDIT_BAR_WIDTH / 2)
		);
		const nodeBarY = computed(() =>
			 Scale.y(currentNode.value?.y + currentNode.value?.borderWidth + currentNode.value?.height / 2 + mapAreaService.y, props.ctx.canvas.height / 2, props.zoomLevel) / props.pixelRatio + PADDING_VERTICAL / props.pixelRatio
		);

		const edgeBarX = computed(() =>
			Scale.x(currentEdge.value?.middlePoint.x + mapAreaService.x, props.ctx.canvas.width / 2, props.zoomLevel) / props.pixelRatio - (EDIT_BAR_WIDTH  / 2)
		);
		const edgeBarY = computed(() =>
			Scale.y(currentEdge.value?.middlePoint.y + mapAreaService.y, props.ctx.canvas.height / 2, props.zoomLevel) / props.pixelRatio + PADDING_VERTICAL / props.pixelRatio
		)

		const computedX = computed(() => currentNode.value ? nodeBarX.value : edgeBarX.value);
		const computedY = computed(() => currentNode.value ? nodeBarY.value : edgeBarY.value);

		return {
			currentNode,
			isContentFormOpened,
			isNodeDesignSettingsOpened,
			isMultiSelection,
			currentEdge,
			computedX,
			computedY
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/sections/editor/quick-edit-bar/edit-bar";
@use "@/scss/sections/editor/quick-edit-bar/edit-row";
</style>
